import CloseIcon from '@mui/icons-material/Close';
import { Box, Chip } from '@mui/material';
import React from 'react';

import type { FilterPillOption } from './types';

export interface FilterPillsProps {
  options: FilterPillOption[];
  value: FilterPillOption[];
  onChange: (value: FilterPillOption[]) => void;
}

const isSelected = (
  option: FilterPillOption,
  value: FilterPillOption[],
): boolean => value.some((v) => v.value === option.value);

const FilterPills: React.FC<FilterPillsProps> = ({
  options,
  value,
  onChange,
}) => {
  const handleToggle = (option: FilterPillOption) => {
    const selected = isSelected(option, value);
    if (selected) {
      onChange(value.filter((v) => v.value !== option.value));
    } else {
      onChange([...value, option]);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      {options.map((option) => {
        const selected = isSelected(option, value);
        return (
          <Chip
            key={option.value}
            label={option.label}
            onClick={() => handleToggle(option)}
            onDelete={() => handleToggle(option)}
            deleteIcon={<CloseIcon sx={{ fontSize: 16 }} />}
            variant="outlined"
            size="medium"
            sx={{
              ...(selected
                ? {
                    borderColor: 'primary.main',
                    color: 'primary.main',
                    '& .MuiChip-deleteIcon': {
                      color: 'primary.main',
                    },
                  }
                : {
                    borderColor: 'divider',
                    color: 'text.secondary',
                    '& .MuiChip-deleteIcon': {
                      color: 'action.active',
                    },
                  }),
            }}
          />
        );
      })}
    </Box>
  );
};

export default FilterPills;
